import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { guideQuery } from '@/api/modules/guide.js';
export default {
  data: function data() {
    return {
      header: {},
      steps: [{
        title: 'step1：在线下完成「学习分册」中的知识运用及「练习分册」中的练习卡片',
        img: this.$resource('guide-study-tip-step1.png')
      }, {
        title: 'step2：在线上通过练习所在页码唤起提交页码',
        img: this.$resource('guide-study-tip-step2.png')
      }, {
        title: 'step3：在「提交错题」页面或「查看解析」页面提交作答结果',
        img: this.$resource('guide-study-tip-step3.png')
      }]
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$guideQuery, data, status, tipInfo;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return guideQuery({
                codes: ['C0002']
              });

            case 2:
              _yield$guideQuery = _context.sent;
              data = _yield$guideQuery.data;
              status = _yield$guideQuery.status;

              if (!(status !== 1 || !(data !== null && data !== void 0 && data[0]))) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              tipInfo = JSON.parse(data[0].content || '{}');
              _this.header = tipInfo.header;
              _this.steps = tipInfo.content;

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};